import React from 'react';
import { detailsFooter, detailsSocial } from '../../data/Data';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      {/* Left Column: Footer Details */}
      <div className="footer__left">
        {detailsFooter.map((item) => (
          <div key={item.id} className="footer__item">
            <h4 className="footer__title">{item.title}</h4>
            <p className="footer__text">{item.status}</p>
          </div>
        ))}
      </div>

      {/* Right Column: Shop Button and Social Links */}
      <div className="footer__right">
        <div className="footer__shop">
          <a
            href="https://www.etsy.com/shop/NatlAphasiaSynergy?ref=profile_header"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__shop-button"
          >
            Shop
          </a>
        </div>
        <div className="footer__social">
          {detailsSocial.map((item) => (
            <a
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
            >
              <img src={item.icon} alt="social-icon" className="footer__icon" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}